// extracted by mini-css-extract-plugin
module.exports = {"Progress_Status":"loading_Progress_Status__2T5J3","myprogressBar":"loading_myprogressBar__1cOlF","Progress_Text":"loading_Progress_Text__3aYUx"};